import * as CL from '@design-system/component-library';
import { pictureStorageBaseUrl } from '../Picture/contentfulImageProxy';

const CTAButton = () => {
  const Variation = {
    FIVEG100: '5g_100',
    FIVEG300: '5g_300',
  } as const;

  // Frosmo stuff gets loaded asynchronously, so we need to scroll to the element instead of using a ref
  const handleScroll = (variation: (typeof Variation)[keyof typeof Variation]) => {
    // analytics
    window.dataLayer?.push({
      event: 'cta_click',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      click_element_parent: `Yritysliittymät carousel - ${variation}`,
    });
    const element = document.getElementById('fr-liittyma-wrapper');
    if (element) {
      element.scrollIntoView();
    }
  };
  return (
    <>
      <CL.Button
        onClick={() => handleScroll(Variation.FIVEG100)}
        size="s"
        className="of-public-mobile-voice-subscriptions-campaign__submit of-public-mobile-voice-subscriptions-campaign__submit--mobile"
      >
        Tutustu ja tilaa
      </CL.Button>
      <CL.Button
        onClick={() => handleScroll(Variation.FIVEG300)}
        size="m"
        className="of-public-mobile-voice-subscriptions-campaign__submit of-public-mobile-voice-subscriptions-campaign__submit--desktop"
      >
        Tutustu ja tilaa
      </CL.Button>
    </>
  );
};

type CarouselItemProps = {
  imgSrc: string;
  heading: string;
  subheading: string;
  description: React.ReactNode;
};

const CarouselItem = ({ imgSrc, heading, subheading, description }: CarouselItemProps) => (
  <div className="of-public-mobile-voice-subscriptions-campaign__item">
    <img src={imgSrc} className="of-public-mobile-voice-subscriptions-campaign__image" alt="Campaign hero" />
    <div className="of-public-mobile-voice-subscriptions-campaign__content">
      <h3 className="of-public-mobile-voice-subscriptions-campaign__heading">{heading}</h3>
      <h4 className="of-public-mobile-voice-subscriptions-campaign__subheading">{subheading}</h4>
      <div className="of-public-mobile-voice-subscriptions-campaign__description">{description}</div>
      <CTAButton />
    </div>
  </div>
);

export const PublicMobileVoiceSubscriptionsCampaign = () => {
  return (
    <section className="of-public-mobile-voice-subscriptions-campaign">
      <CL.Carousel
        buttons="primary"
        i18n_next_button_label="Seuraava"
        i18n_next_button_loop_label="Ensimmäinen"
        i18n_previous_button_label="Edellinen"
        i18n_previous_button_loop_label="Viimeinen"
        indicators
        loop
      >
        {[
          <CarouselItem
            imgSrc={`${pictureStorageBaseUrl}tUGC7qTUDoUVt69S5NKsg/GettyImages-1192884594.jpg?w=1920`}
            heading="Rehellisesti kotimainen ja turvallinen liittymä kevyeen käyttöön"
            subheading="Yritysliittymä 5G 100M, hintaan 23,99€/kk"
            description={
              <ul>
                <li>Laadukas yhteys ja kustannusten minimointi</li>
                <li>Henkilölle, jonka työ ja arki eivät ole digitaalisessa maailmassa.</li>
                <li>Liittymällä käytät mobiilivarmennetta veloituksetta.</li>
              </ul>
            }
            key="1"
          />,
          <CarouselItem
            imgSrc={`${pictureStorageBaseUrl}dxGUslvec2sgC4KeHqA4p/GettyImages-1192884634.jpg?w=1920`}
            heading="Rehellisesti kotimainen ja turvallinen liittymä aktiivikäyttöön"
            subheading="Yritysliittymä 5G+ 300M, hintaan 28,99€/kk"
            description={
              <ul>
                <li>Kännykän ja sovellusten aktiivikäyttäjälle</li>
                <li>
                  Matkapuhelinvastaaja varmistaa, ettet menetä tärkeää puhelua, vaikka puhelin on kiinni tai olet
                  lomalla.
                </li>
                <li>Liittymällä käytät mobiilivarmennetta veloituksetta.</li>
              </ul>
            }
            key="2"
          />,
        ]}
      </CL.Carousel>
    </section>
  );
};
